import { CheckIcon, XIcon } from '@phosphor-icons/react';
import Latex from '../../../../../apps/frontend/src/components/global/Latex';

const isMarkedThisOption = (currentSolution, option) => {
  if (currentSolution.markedOptions?.some((e) => e.optionId === option.id)) {
    return true;
  }
  return false;
};

const getOption = (currentSolution, option, index, comparisonData = null, showComparison = true) => {
  const isMarked = isMarkedThisOption(currentSolution, option);

  return (
    <div className="w-full h-full mb-3 image-invert-wrapper" key={index}>
      <div className="relative h-full">
        <div
          className={`h-full overflow-x-auto flex items-center mb-0 rounded-[12px] border ${
            showComparison
              ? option.isCorrect
                ? 'border-[var(--q3-green-normal)]'
                : !option.isCorrect &&
                    isMarked &&
                    (currentSolution?.status === 'answered' || currentSolution?.status === 'answeredReview')
                  ? 'border-[var(--q3-danger-normal)]'
                  : 'border-transparent bg-[var(--q3-surface-dim)]'
              : 'border-transparent bg-[var(--q3-surface-dim)]'
          }`}
        >
          <div className="px-4 py-3 flex items-center">
            <div className="flex items-center">
              {/* Avatar */}
              <div className="mr-4">
                <div
                  className={`w-8 h-8 text-sm sm:text-base sm:w-10 sm:h-10 rounded-full flex items-center text-center justify-center text-[var(--q3-neutral-default)] ${
                    showComparison
                      ? option.isCorrect
                        ? 'bg-[var(--q3-green-light)]'
                        : !option.isCorrect &&
                            isMarked &&
                            (currentSolution?.status === 'answered' || currentSolution?.status === 'answeredReview')
                          ? 'bg-[var(--q3-danger-light)]'
                          : 'bg-[var(--q3-surface-default)]'
                      : 'bg-[var(--q3-surface-default)]'
                  }`}
                >
                  {String.fromCharCode('A'.charCodeAt(0) + index)}
                </div>
              </div>

              <div className="flex flex-col">
                <Latex>{option.text}</Latex>
                {showComparison && comparisonData && comparisonData?.optionAnalysis?.[option.id] && (
                  <p className="text-[var(--q3-accent-normal)] mt-1 text-xs">
                    {comparisonData?.optionAnalysis?.[option.id] + '% marked this'}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {showComparison &&
          (option.isCorrect ||
            (!option.isCorrect &&
              isMarked &&
              (currentSolution?.status === 'answered' || currentSolution?.status === 'answeredReview'))) && (
            <div className="absolute -top-3.5 right-4">
              <span
                className={`px-3 py-1 ${option.isCorrect ? 'text-[var(--q3-green-normal)]' : 'text-[var(--q3-danger-normal)]'} text-sm font-medium flex items-center gap-1 bg-[var(--q3-surface-default)] rounded`}
              >
                {option.isCorrect ? (
                  <>
                    {isMarked ? 'Your Answer • Correct' : 'Correct'}
                    <div className="rounded-full bg-[var(--q3-green-normal)] p-[2.4px]">
                      <CheckIcon color="var(--q3-neutral-default)" />
                    </div>
                  </>
                ) : (
                  <>
                    {isMarked ? 'Your Answer • Incorrect' : 'Incorrect'}
                    <div className="rounded-full bg-[var(--q3-danger-normal)] p-[2.4px] text-[var(--q3-neutral-default_inverted)]">
                      <XIcon size={16} color="var(--q3-neutral-default)" />
                    </div>
                  </>
                )}
              </span>
            </div>
          )}
      </div>
    </div>
  );
};

const getNumericalOption = (currentSolution, comparisonData = {}, showComparison = true) => {
  const correctValue = currentSolution?.questionId?.correctValue;

  return (
    <div className="w-full flex flex-col md:flex-row gap-4 mb-4">
      {currentSolution.status === 'answered' || currentSolution.status === 'answeredReview' ? (
        <div className="flex-1 bg-[var(--q3-surface-dim)] rounded-lg">
          <div className="px-4 py-3 flex flex-col justify-center h-full">
            <div className="flex items-center justify-between px-2">
              <div className="flex flex-col gap-y-1 text-base font-medium text-[var(--q3-neutral-default)]">
                <div>{currentSolution?.inputValue?.value}</div>
                {showComparison && comparisonData?.correctPercentage && currentSolution?.inputValue?.isCorrect && (
                  <div className="text-[var(--q3-accent-normal)] text-xs">
                    {comparisonData.correctPercentage}% got it correct
                  </div>
                )}
              </div>
              {showComparison && (
                <div
                  className={`text-sm font-medium flex items-center ${currentSolution?.inputValue?.isCorrect ? 'text-[var(--q3-success-normal)]' : 'text-[var(--q3-danger-normal)]'}`}
                >
                  <div className="mx-[6px]">Your Answer</div>
                  <div
                    className={`${currentSolution?.inputValue?.isCorrect ? 'bg-[var(--q3-success-normal)]' : 'bg-[var(--q3-danger-normal)]'} w-6 h-6 text-center rounded-full p-[2.4px]`}
                  >
                    {currentSolution?.inputValue?.isCorrect ? (
                      <CheckIcon size={20} className="text-[var(--q3-neutral-default_inverted)]" />
                    ) : (
                      <div className="text-[var(--q3-neutral-default_inverted)]">X</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-1 bg-[var(--q3-surface-dim)] rounded-lg">
          <div className="px-4 py-3 flex flex-col justify-center h-full">
            <div className="flex items-center justify-between px-2">
              <div className="flex flex-col gap-y-1 text-base font-medium text-[var(--q3-neutral-default)]">
                <div>{correctValue}</div>
                {showComparison && comparisonData?.correctPercentage && (
                  <div className="text-[var(--q3-accent-normal)] text-xs">
                    {comparisonData.correctPercentage}% got it correct
                  </div>
                )}
              </div>
              {showComparison && (
                <div className="text-sm font-medium flex items-center text-[var(--q3-success-normal)]">
                  <div className="mx-[6px]">Correct Answer</div>
                  <div className="bg-[var(--q3-success-normal)] rounded-full p-[2.4px]">
                    <CheckIcon size={20} className="text-[var(--q3-neutral-default_inverted)]" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {(currentSolution?.status === 'answered' || currentSolution?.status === 'answeredReview') &&
      !currentSolution?.inputValue?.isCorrect ? (
        <div className="flex-1 bg-[var(--q3-surface-dim)] rounded-lg">
          <div className="px-4 py-3 flex flex-col justify-center h-full">
            <div className="flex items-center justify-between px-2">
              <div className="flex flex-col gap-y-1 text-base font-medium text-[var(--q3-neutral-default)]">
                <div>{correctValue}</div>
                {showComparison && comparisonData?.correctPercentage && (
                  <div className="text-[var(--q3-accent-normal)] text-xs">
                    {comparisonData.correctPercentage}% got it correct
                  </div>
                )}
              </div>
              {showComparison && (
                <div className="text-sm font-medium flex items-center text-[var(--q3-success-normal)]">
                  <div className="mx-[6px]">Correct Answer </div>
                  <div className="bg-[var(--q3-success-normal)] rounded-full p-[2.4px]">
                    <CheckIcon size={20} className="text-[var(--q3-neutral-default_inverted)]" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex-1 bg-[var(--q3-surface-default)]"></div>
      )}
    </div>
  );
};

export { getNumericalOption, getOption, isMarkedThisOption };
